import React from 'react';
import styled from 'styled-components';

import BlackBackground from './BlackBackground';
import WhiteBackground from './WhiteBackground';
import Alphabet from '../Alphabet';

export default function Footer(){
  return <Container>
    <Alphabet />
    <BlackBackground />
    <WhiteBackground />
  </Container>
}

const Container = styled.footer`
  width: 100%;
  margin-top: auto;
`